// extracted by mini-css-extract-plugin
export default {"link":"navigation-link_link__QAPip","text":"navigation-link_text__nzuE8","arrowLeft":"navigation-link_arrowLeft__iKSjj","arrowRight":"navigation-link_arrowRight__+1yFd"};